class Cursors {
    constructor(prev, next) {
        this.prev = prev;
        this.next = next;
    }
}
function isCursorDefined(cursor) {
    return typeof cursor === 'string' && cursor.length > 0;
}
export { Cursors, isCursorDefined };
//# sourceMappingURL=cursors.js.map